import { useEffect } from 'react';
import { message } from 'antd';
import { getAllGarages } from '$app/common/api';

const useGetActiveGarages = (setGarages) => {
  useEffect(() => {
    const getActiveGarages = async () => {
      try {
        const garages = await getAllGarages();
        const activeGarages = garages.filter(({ status }) => status === 'ACTIVE');
        setGarages(activeGarages);
      } catch (error) {
        message.error(error);
      }
    };

    getActiveGarages();
  }, [setGarages]);
};

export default useGetActiveGarages;
